class FleetPageTransform {
  constructor() {
    "ngInject";
  }

  justify() {}
}

export default FleetPageTransform;



// WEBPACK FOOTER //
// ./src/pages/fleet/fleet.transforms.js